/**
 * TrackerHeldNotice — calm amber one-liner in the drawer's Status row while
 * the tracker's own Flow Optimizer switch holds it (Tres Commas): "… is held —
 * nothing is pushed", with the reason behind its ⓘ. Renders nothing without
 * a reason — Voluum and Binom have no such switch.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { AlertTriangle, Info } from 'lucide-react';
import { trackerLabel, type TrackerId } from '@trafficpulse/shared';

import { Tooltip } from '@/components/ui/Tooltip';

export interface TrackerHeldNoticeProps {
  provider: TrackerId;
  /** Why the tracker's own switch holds it, or null (renders nothing). */
  reason: string | null;
}

export const TrackerHeldNotice: FC<TrackerHeldNoticeProps> = ({ provider, reason }) => {
  if (!reason) return null;
  const label = trackerLabel(provider);
  const text = `${label} Flow Optimizer is held — nothing is pushed`;
  return (
    <span
      role="status"
      className="inline-flex min-w-0 max-w-[min(28rem,50vw)] items-center gap-1 rounded-md border border-warning/40 bg-warning/10 px-1.5 py-0.5 text-[11px] font-medium leading-none text-warning"
    >
      <AlertTriangle className="h-3 w-3 shrink-0" aria-hidden />
      <span className="truncate" title={text}>
        {text}
      </span>
      <Tooltip content={reason} side="bottom" contentClassName="max-w-sm">
        <Info className="h-3 w-3 shrink-0 cursor-help" aria-label={`Why ${label} is held`} />
      </Tooltip>
    </span>
  );
};

export default TrackerHeldNotice;
